import { render, staticRenderFns } from "./FoodCategory.vue?vue&type=template&id=ce3ec126&"
import script from "./FoodCategory.vue?vue&type=script&lang=js&"
export * from "./FoodCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports